"use client"

import styled from "@emotion/styled"
import CommonTitle from "../common/bit/CommonTitle"
import BlockWrapper from "../common/BlockWrapper"
import DetailsImageSwiperCard from "../common/DetailsImageSwiperCard"
import SwiperOnMobile from "../SwiperOnMobile/SwiperOnMobile"
import { mediaQueries } from "../theme/mediaQueries"

const StyledCardsListSwiperOnMobile = styled(SwiperOnMobile)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  ${mediaQueries.mobile} {
    align-items: stretch;
    overflow: hidden;
    .swiper {
      width: 100%;
    }
  }
`
const StyledBlockWrapper = styled(BlockWrapper)`
  padding-bottom: 80px;
`

const DetailsImageSwiperCardsList = ({ data }: any) => {
  const { title, itemsList } = data

  return (
    <StyledBlockWrapper>
      {title.value && <CommonTitle title={title.value} />}
      <StyledCardsListSwiperOnMobile
        arrowIconName="arrow_lightPink_black_line"
        swiperProps={{
          slidesPerView: 1,
          navigation: true,
          loop: false,
          autoHeight: true,
        }}
      >
        {itemsList &&
          itemsList?.blocks.map((item: any, index: number) => {
            return (
              <DetailsImageSwiperCard
                item={item}
                key={`details-image-swiper-cards-${index}`}
              />
            )
          })}
      </StyledCardsListSwiperOnMobile>
    </StyledBlockWrapper>
  )
}

export default DetailsImageSwiperCardsList
